import * as React from 'react'

/**
 * @description RuMarket icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { RuMarket } from '@sravni/design-system-icons'
 *
 * <RuMarket />
 * ```
 */
export const RuMarket = React.forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>((props, ref) => (
  <svg ref={ref} data-qa="RuMarket" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M15.111 4.05 19 4.052v8.619s-.088 1.495-.734 2.386a4.752 4.752 0 0 1-.428.502l-.009.008v.001c-.082.08-.332.322-.705.562-.45.29-.918.472-1.401.602-.269.072-.903.225-2.786.23a20.22 20.22 0 0 1-1.49-.042l-.004-1.03v-.123l-.005-1.027-.004-.931v-.11l-.003-.932c.007-.121.005-.34-.095-.586a1.411 1.411 0 0 0-.273-.42c-.192-.206-.397-.301-.615-.405a2.982 2.982 0 0 0-.511-.184 5.295 5.295 0 0 0-1.26-.18c.254-.049 1.41-.298 2.139-1.378a3.16 3.16 0 0 0 .524-1.52l.005 3.834c.003.157.037.815.547 1.321a1.897 1.897 0 0 0 1.316.547h.035a1.868 1.868 0 0 0 1.868-1.868V4.051Zm-6.854-.047a88.01 88.01 0 0 0 3.079.006l.003 3.401c-.022-.334-.128-1.428-1.022-2.348a3.707 3.707 0 0 0-2.06-1.059Z"
      fill="currentColor"
    />
    <path
      d="M7.456 4v8.797c.003.298.036.814.231 1.39a1.336 1.336 0 0 0-.31-.43 2.318 2.318 0 0 0-.642-.433l-.012-.005-.023-.01c-.243-.105-.503-.168-1.108-.231a15.784 15.784 0 0 0-1.34-.082l.03 3.93L1 16.921V4h6.456Zm.631 0a58 58 0 0 0 .17.003 3.705 3.705 0 0 1 2.06 1.06c.853.877.989 1.914 1.019 2.297v.78c-.042.427-.17.954-.52 1.473-.73 1.08-1.885 1.33-2.138 1.378.556.015.98.104 1.259.18.229.063.382.123.511.184.219.104.423.199.615.406.175.188.254.372.273.419.1.246.102.465.095.586l.007 1.973.004.986.001.165.005 1.029c-.592-.044-.835-.11-.979-.155-.8-.243-1.279-.592-1.443-.718-.22-.17-.536-.45-.819-.843a3.84 3.84 0 0 1-.453-.834 1.348 1.348 0 0 0-.067-.183 4.494 4.494 0 0 1-.231-1.389V4h.631Zm-.4 10.187c.03.068.052.13.067.182a4.092 4.092 0 0 1-.067-.182Zm1.171-6.412L4.663 5.703a.36.36 0 0 0-.518.324v4.139c0 .267.281.44.518.323l4.195-2.071a.358.358 0 0 0 0-.643Z"
      fill="currentColor"
    />
  </svg>
))
